import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import styles from './styles.module.scss';

class SubscriptionSuccess extends Component {
    render() {
        return (
            <div className={styles.container}>
                <div className={styles.content}>
                    <div className={styles.successIcon}>✓</div>
                    <h1>Subscription Successful!</h1>
                    <p>Thank you for subscribing to RepOne. Your payment has been processed successfully.</p>
                    <p>You now have access to all premium features.</p>

                    <Link to="/athletes" className={styles.homeButton}>
                        Go to Dashboard
                    </Link>
                </div>
            </div>
        );
    }
}

export default SubscriptionSuccess;
